module.exports = __webpack_public_path__ + "static/media/redCross.797239bb.svg";